import { useEffect, useState } from "react";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import { apiScopes } from "../auth/msalConfig";
import { isAuthConfigured } from "../config";
import LiaiseWordmark from "../brand/LiaiseWordmark";

export default function LoginPage() {
  const { instance } = useMsal();
  const isAuthed = useIsAuthenticated();
  const [redirectFailed, setRedirectFailed] = useState(false);
  const configured = isAuthConfigured();

  // Auto-fire loginRedirect. With an active AAD browser session this bounces
  // straight back — feels like silent SSO.
  useEffect(() => {
    if (!configured || isAuthed) return;
    if (instance.getAllAccounts().length > 0) return;
    instance
      .handleRedirectPromise()
      .then((result) => {
        if (result?.account) return;
        if (instance.getAllAccounts().length > 0) return;
        return instance.loginRedirect({ scopes: apiScopes() });
      })
      .catch((err) => {
        console.error("Login redirect failed", err);
        setRedirectFailed(true);
      });
  }, [instance, isAuthed, configured]);

  if (isAuthed) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen flex items-center justify-center bg-liaise-navy text-white">
      <div className="text-center space-y-8 px-6">
        <LiaiseWordmark className="h-12 w-auto mx-auto" />
        <div className="space-y-2">
          <h1 className="text-3xl font-semibold">Recruitment Assessment</h1>
          <p className="text-white/70">
            {!configured
              ? "This app isn't configured yet (missing Entra client id in config.json)."
              : redirectFailed
                ? "We couldn't sign you in automatically - try the button below."
                : "Signing you in..."}
          </p>
        </div>
        {configured && redirectFailed && (
          <button
            onClick={() => instance.loginRedirect({ scopes: apiScopes() })}
            className="bg-white text-liaise-navy font-medium px-6 py-3 rounded-lg hover:bg-white/90 transition"
          >
            Sign in with Microsoft
          </button>
        )}
        <p className="text-white/50 text-sm pt-8">Your goals are our goals.</p>
      </div>
    </div>
  );
}
